export default __webpack_public_path__ + "static/media/board-preview.14cda5dc.svg";